import { BaseModel } from "@/models/base.model"
import { type IProjectRentalDispenseItem } from "@/interfaces/api/project-rental-dispense-item.interface"

export class ProjectRentalDispenseItem extends BaseModel implements IProjectRentalDispenseItem {
  public static className = "ProjectRentalDispenseItem" // Used for socket communication.
  public static verboseName = "projectverhuurafspraak"

  project: string
  rentalDispenseItem: string

  unitPricePerDay: string

  constructor(projectRentalDispenseItem: IProjectRentalDispenseItem) {
    super(projectRentalDispenseItem)

    this.project = projectRentalDispenseItem.project
    this.rentalDispenseItem = projectRentalDispenseItem.rentalDispenseItem

    this.unitPricePerDay = projectRentalDispenseItem.unitPricePerDay
  }
}
